import { ListSubheaderProps, ListSubheader as MuiListSubheader } from '@mui/material';

type Props = Pick<ListSubheaderProps, 'children' | 'className' | 'sx'> & {
  testId?: string;
};

const ListSubheader = ({ children, className, testId, sx }: Props) => {
  return (
    <MuiListSubheader className={className} test-id={testId} sx={sx}>
      {children}
    </MuiListSubheader>
  );
};

export default ListSubheader;
